import React, { Component } from 'react'
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Loader } from "react-overlay-loader";
import ReactTable from "react-table"
import 'react-table/react-table.css'

class ClaimReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start_date: new Date(),
      end_date: new Date(),
      choosen_org: '',
      choosen_status: '',
      lov_branch: [],
      dataTable: [],
      loading: false,
      user: JSON.parse(window.localStorage.getItem('is_user')),
      program_desc: ''
    }
  }

  componentDidMount = async () => {
    if (this.state.user.role_name !== 'CHD-HO') {
      this.dataBranch()
    }
  }

  dataBranch = () => {
    let { user } = this.state
    let url = '/api/traces_chd/v1/report/branch-list'
    request.getCHD(url, {
      success: function(response) {
        let { data } = response.data
        let find = _.find(data, function(o) {
          return o.org_id === user.org_id
        })

        // If not found, then push to LOV
        if (!find) {
          data.push({
            org_id: user.org_id,
            org_initial: user.org_initial,
            org_name: user.org_name
          })
        }
        
        this.setState({ lov_branch: response.data.data || [], choosen_org: user.origin === 'HO' ? 'ALL' : user.org_id })
      }.bind(this),
      error: function(e) {
        console.log(e)
      }.bind(this)
    })
  }

  handleChangeBranch = (e) => {
    let value = e.currentTarget.value
    this.setState({ choosen_org: parseInt(value) })
  }

  renderBranch = () => {
    let { user } = this.state
    return (
      <div className="col-md-4">
        <small><strong>Branch</strong></small>
        <select className="form-control form-control-sm" value={this.state.choosen_org} disabled={user.origin !== 'HO' ? true : false } onChange={this.handleChangeBranch.bind(this)}>
          <option value="">- Select Branch -</option>
          <option value={'ALL'}>ALL</option>
          {
            this.state.lov_branch.map((item, index) => (
              <option value={item.org_id}>{item.org_name}</option>
            ))
          }
        </select>
      </div>
    )
  }
  
  handleStartDate = async (date) => {
    this.setState({ start_date: date })
  }

  handleEndDate = async (date) => {
    this.setState({ end_date: date })
  }

  handleChangeStatus = (e) => {
    let value = e.currentTarget.value
    this.setState({ choosen_status: value })
  }

  renderLovStatus = () => {
    return (
      <div>
        <small><strong>Claim Status</strong></small>
        <select className="form-control form-control-sm" onChange={this.handleChangeStatus.bind(this)}>
          <option value={""}>- Select Status -</option>
          <option value={'A'}>APPROVE</option>
          <option value={'R'}>REJECT</option>
          <option value={'D'}>PROPOSED</option>
          <option value={'S'}>SUSPENDED BY RECEIPT</option>
        </select>
      </div>
    )
  }

  renderFilter = () => {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="card-body pt-1">
              <div className="row">
                { this.renderBranch() }
                <div className="col-md-4">
                  <small><strong>From (Claim Date)</strong></small>
                  <div className="customDatePickerWidth">
                    <DatePicker
                      selected={this.state.start_date}
                      maxDate={this.state.end_date}
                      dateFormat="d-MMM-yyyy"
                      className="form-control form-control-sm"
                      popperPlacement="top-end"
                      onChange={this.handleStartDate}
                    />  
                  </div>
                </div>
                <div className="col-md-4">
                  <small><strong>To (Claim Date)</strong></small>
                  <div className="customDatePickerWidth">
                    <DatePicker
                      minDate={this.state.start_date}
                      selected={this.state.end_date}
                      dateFormat="d-MMM-yyyy"
                      className="form-control form-control-sm"
                      popperPlacement="top-end"
                      onChange={this.handleEndDate}
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <small><strong>Program Desc:</strong></small>
                  <input value={this.state.program_desc} onChange={(e) => this.setState({program_desc: e.target.value})} type="text" className="form-control form-control-sm" placeholder="Program Desc" />
                </div>
                <div className="col-md-6">{ this.renderLovStatus()}</div>
              </div>
              <div className="row mt-4">
                <div className="col-md-3">
                  <button type="button" className="btn btn-primary btn-block" onClick={ this.handleSearch.bind(this) }><i className="fa fa-search" /> Search</button>
                </div>
                <div className="col-md-3">
                  <button type="button" className="btn btn-success btn-block" onClick={ this.handleExport.bind(this) }><i className="fa fa-file-excel" /> Export To Excel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleSearch = () => {
    let { choosen_org, user } = this.state
    let branch = {}
    if (choosen_org !== 'ALL') {
      branch = _.find(this.state.lov_branch, function(o) {
        return o.org_id === choosen_org
      })
    } else {
      branch.org_name = 'ALL'
    }

    let url = '/api/traces_chd/v1/report/claim'
    let param = {
      branch: branch ? branch.org_name : '',
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      status: this.state.choosen_status,
      program_desc: this.state.program_desc
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        console.log(response.data)
        this.setState({ loading: false, dataTable: response.data.data || [] })
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: 'No. IM / Ref. Number',
          accessor: 'ref_number',
          filterable: true
        },
        {
          Header: 'Program Desc',
          accessor: 'program_desc',
          filterable: true
        },
        {
          Header: 'CABANG',
          accessor: 'cabang',
          filterable: true
        },
        {
          Header: 'NAMA RELASI',
          accessor: 'nama_relasi',
          filterable: true
        },
        {
          Header: 'BANK',
          accessor: 'bank',
          filterable: true
        },
        {
          Header: 'BI CODE',
          accessor: 'bi_code',
          filterable: true
        },
        {
          Header: 'NO REKENING',
          accessor: 'no_rekening',
          filterable: true
        },
        {
          Header: 'PEMILIK REKENING',
          accessor: 'pemilik_rekening',
          filterable: true
        },
        {
          Header: 'CLAIM NUMBER',
          accessor: 'claim_number',
          filterable: true
        },
        {
          Header: 'NETT CLAIM',
          accessor: 'nett_claim',
          filterable: true
        },
        {
          Header: 'PPH',
          accessor: 'pph',
          filterable: true
        },
        {
          Header: 'PPH TYPE',
          accessor: 'pph_type',
          filterable: true
        },
        {
          Header: 'PPH RATE',
          accessor: 'pph_rate',
          filterable: true
        },
        {
          Header: 'VALUE GROSS UP',
          accessor: 'value_gross_up',
          filterable: false
        },
        {
          Header: 'PERIOD',
          accessor: 'period',
          filterable: true
        },
        {
          Header: 'NPWP',
          accessor: 'npwp',
          filterable: true
        },
        {
          Header: 'NPWP NAME',
          accessor: 'npwp_name',
          filterable: true
        },
        {
          Header: 'NPWP ADDRESS',
          accessor: 'npwp_address',
          filterable: true
        },
        {
          Header: 'CLAIM STATUS',
          accessor: 'status',
          filterable: true
        },
        {
          Header: 'NO INVOICE',
          accessor: 'ap_invoice_no',
          filterable: true
        },
        {
          Header: 'STATUS KWITANSI',
          accessor: 'scan_kwitansi',
          filterable: true
        },
        {
          Header: 'TANGGAL TRANSFER',
          accessor: 'ap_transfer_date',
          filterable: true
        },
        {
          Header: 'PAYMENT PROCESS NO',
          accessor: 'payment_process_no',
          filterable: true
        },
      ],
      rows: this.state.dataTable
    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
      defaultFilterMethod={((filter, row, column) => {
        let columnes = row[filter.id]
        return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
      })}
    />)
  }

  handleExport = () => {
    let { choosen_org } = this.state
    let branch = _.find(this.state.lov_branch, function(o) {
      return o.org_id === choosen_org
    })
    let url = '/api/traces_chd/v1/report/claim'
    let param = {
      branch: branch ? branch.org_name : '',
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      status: this.state.choosen_status,
      export: true,
      program_desc: this.state.program_desc
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let data = response.data.data
        this.setState({ loading: false, dataTable: data.data || [] })
        if (data.fullpath) {
          window.open(data.fullpath, '_blank')
          return false
        }
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }
  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-header">Report Claim</div>
                    <div className="card-body">
                      { this.renderFilter() }
                      { this.renderTable() }
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
          <Loader fullPage loading={this.state.loading} />
      </div>
    )
  }
}

export default ClaimReport